export const fptiMetadata = {
  BP_PGRP: 'main:bizprofileweb:sellermgmt:viewprofile',
  ERROR_PAGE_SOURCE: 'viewprofile',
  GENERIC_ERROR_PAGE: 'genericerror',
  NO_PROFILE_ERROR_PAGE: 'profilenotfound',
  NO_PROFILE_EVENT: 'seller_b_profile_not_found',
  GENERIC_ERROR_EVENT: 'seller_b_profile_server_error',
}
